import React, {createContext, useState} from 'react';
import cx from 'classnames';
import {HTMLDialog} from '@priority-software/priority-style-react';
import {RuleType} from '../../enums';
import {AutomationsOverview} from './parts/AutomationsOverview/index';
import {overviewDialogID} from '../../constants';
import dialogCSS from '../../common-dialog-styles.module.scss';

type Props = {
    session: string;
    type: RuleType;
    onClose: () => void;
    isOpen: boolean;
    toolbarContent?: React.ReactNode;
};

export const AutomationsOverviewContext = createContext({
    lockKeyboardInteraction: false,
    toggleKeyboardInteraction: (flag: boolean) => {}
});

export const RulesListDialog = (props: Props) => {
    const {session, isOpen, type, onClose, toolbarContent} = props;
    const [lockKeyboardInteraction, toggleKeyboardInteraction] = useState(false);

    if (!session) return null;

    return (
        <AutomationsOverviewContext.Provider
            value={{lockKeyboardInteraction, toggleKeyboardInteraction}}
        >
            <HTMLDialog
                id={overviewDialogID}
                escClosable={true}
                isOpen={isOpen}
                onClose={onClose}
                componentClasses={cx(dialogCSS.component, dialogCSS.paddingBottom0, 'reactComp')}
                toolbarContent={toolbarContent}
                content={<AutomationsOverview type={type} session={session} />}
                size="large"
            />
        </AutomationsOverviewContext.Provider>
    );
};
